import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Suppress wallet-related errors
    const errorMessage = error?.message || '';
    
    if (
      errorMessage.includes('MetaMask') || 
      errorMessage.includes('Failed to connect') ||
      errorMessage.includes('ethereum') ||
      errorMessage.includes('wallet') ||
      errorMessage.includes('Connector') ||
      errorMessage.includes('provider')
    ) {
      console.log('Wallet error caught and suppressed by ErrorBoundary');
      // Reset error state for wallet errors
      this.setState({ hasError: false });
      return;
    }
    
    // Log other errors
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          background: '#000',
          color: '#fff',
          flexDirection: 'column',
          gap: '20px'
        }}>
          <h1>Something went wrong.</h1>
          <button 
            onClick={() => window.location.reload()}
            style={{
              background: '#00FFD1',
              color: '#000',
              padding: '12px 24px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600'
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
